import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { CrmLead } from '@utils/models/CrmLeadList';
import { DebtList } from '@utils/models/DebtList';
import { useQuery } from 'react-query';

export function useGetSelectedLead() {
  const chatFlowId = useAppSelector(state => state.aiAgentReducer.body.id);
  const open = useAppSelector(state => state.aiAgentReducer.simulation?.open);

  return useQuery<(CrmLead & DebtList) | null>({
    queryKey: ['selected-lead', chatFlowId],
    queryFn: async () => {
      const res = await $api.get(`/v1/chat-flow/answer/default-data/${chatFlowId}`);

      return res.data?.data;
    },
    enabled: !!chatFlowId && open
  });
}
